import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ScriptTag from "react-script-tag";
import MemberHelper from "../../helpers/MemberHelper";
import { connect } from "react-redux";
import { Layouts } from "../../constants/Constants";
import LiveChatDisable from "../../assets/img//chat_bubble_disable.png";
import { liveAgentSettings } from "./liveAgentSettings";
import styles from "../../assets/css/modules/contact-us/online-link.css";
import {
  initialiseLiveAgentForMOL,
  initialiseLiveAgentForHOL
} from "./initialiseLiveAgent";

export function mapStateToLiveAgent({
  policyReducer = {},
  navigationMenuReducer = {},
  layoutReducer = {}
}) {
  let selectedPolicy = policyReducer.selectedPolicy;
  let loggedInMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    selectedPolicy
  );
  let selectedMenu = navigationMenuReducer.selectedMenu;
  return {
    lastName: loggedInMember.LastName,
    firstName: loggedInMember.FirstName,
    fullName: loggedInMember.FullName,
    membershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    selectedMenu,
    layout: layoutReducer.layout,
    layoutN: layoutReducer.layout === "HOL" ? "hol" : "mol",
    isFormat2: selectedPolicy && selectedPolicy.IsFormat2,
    clientId: loggedInMember && loggedInMember.ClientId
  };
}

var eswJsPath = "";
export class LiveAgent extends Component {

  componentDidMount() {   
    if (this.props.layout === Layouts.HOL) {
      eswJsPath = window.axa.liveAgentMIAW.hol.eswJsPath;
    }
    else{
      eswJsPath = window.axa.liveAgentMIAW.mol.eswJsPath;
    }
  }

  componentDidUpdate() {
    this.updateESW();
  }

  updateESW = function () {
    var elements = document.getElementsByClassName("embeddedMessagingConversationButton");
    if (elements && elements.length > 0) {
      if(elements[0].style.display !== "none" && document.getElementById("contactUsChat")){
       document.getElementById("contactUsChat").getElementsByTagName('a')[0].className = styles.onlineLink;
      }
      else if(document.getElementById("contactUsChat")){
        document.getElementById("contactUsChat").getElementsByTagName('a')[0].className = styles.disabledchat;
      }
      this.initEmbeddedMessaging();
    }
    else 
    {
      if(document.getElementsByClassName("livechatImage") && document.getElementsByClassName("livechatImage").length>0)
      {
      document.getElementsByClassName("livechatImage")[0].src=LiveChatDisable;      
      document.getElementsByClassName("livechatLink")[0].style.display = 'none';
      document.getElementsByClassName("livechatText")[0].style.display = 'inline';  
      }
       if(document.getElementById("contactUsChat")){
        document.getElementById("contactUsChat").getElementsByTagName('a')[0].className = styles.disabledchat;
      }
    }
  };

  initEmbeddedMessaging = function () {

    var settings = liveAgentSettings(
      this.props.membershipNumber,
      this.props.firstName,
      this.props.lastName,
      this.props.fullName
    );

    window.embeddedservice_bootstrap.settings = {
      ...window.embeddedservice_bootstrap.settings,
      ...settings
    };

    if (this.props.layout === Layouts.HOL) {
      initialiseLiveAgentForHOL();
    } else {
      initialiseLiveAgentForMOL();
    }

  }

  render() {
    return (
      <React.Fragment>
        <ScriptTag
          onLoad={() => {
              this.initEmbeddedMessaging();
          }}
          type="text/javascript"
          src = {eswJsPath}
        />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToLiveAgent)(withRouter(LiveAgent));
